export const CODE_ISO3_FRANCE = 'FRA';

export const DEPARTEMENTS_IDF = ["75", "77", "78", "91", "92", "93", "94", "95"];

export const ROLES_GPEC = ["CORRESPONDANT_GPEC_LECTURE", "CORRESPONDANT_GPEC_ADMINISTRATEUR", "CORRESPONDANT_GPEC_UTILISATEUR"];

export const ROLES_SECURITE = ["CORRESPONDANT_SECURITE_LECTURE", "CORRESPONDANT_SECURITE_ADMINISTRATEUR", "CORRESPONDANT_SECURITE_UTILISATEUR"];

export const ROLES_EMPREINTE = ["CORRESPONDANT_EMPREINTE_LECTURE", "CORRESPONDANT_EMPREINTE_ADMINISTRATEUR", "CORRESPONDANT_EMPREINTE_UTILISATEUR"];

export const ROLES_EFFECTIFS = ["CORRESPONDANT_EFFECTIFS_LECTURE", "CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR", "CORRESPONDANT_EFFECTIFS_UTILISATEUR"];

export const ROLES_ADMIN = ["ADMINISTRATEUR", "CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR", "CORRESPONDANT_GPEC_ADMINISTRATEUR", "CORRESPONDANT_EMPREINTE_ADMINISTRATEUR", "CORRESPONDANT_SECURITE_ADMINISTRATEUR"];